import React, { useContext } from "react";
import emailjs from 'emailjs-com';
import "./Contact.css";
import { contactInfo } from "../../portfolio";
import { Fade } from "react-reveal";
import StyleContext from "../../contexts/StyleContext";
import ContactImg from "../../img/img-01.png"

export default function Contact() {
  const { isDark } = useContext(StyleContext);
  function sendEmail(e) {
    e.preventDefault();

    emailjs.sendForm('service_e9os3qb', 'template_ee45ir6', e.target, 'user_IzW1o0AdrgCQClLZixn0V')
      .then((result) => {
        console.log(result.text);
      }, (error) => {
        console.log(error.text);
      });
  }
  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="row m-0">
        <div className="main contact-margin-top bg-img" id="contact">
          <div className="contact-div-main">
            <div className="contact-header">
              <h1 className="heading contact-title">{contactInfo.title}</h1>
              <p
                className={
                  isDark
                    ? "dark-mode contact-subtitle"
                    : "subTitle contact-subtitle"
                }
              >
                {contactInfo.subtitle}
              </p>

              <div
                className={
                  isDark ? "dark-mode contact-text-div" : "contact-text-div"
                }
              >
               
                <div className="row pt-5 m-0">
                  <div class="wrap-contact100">
                    <div class="contact100-pic js-tilt col-sm-6" data-tilt>
                      <img src={ContactImg} alt="IMG" />
                    </div>


                    <div className="col-sm-6">
                      <form class="contact100-form validate-form form-group" onSubmit={sendEmail}>
                        <span class="contact100-form-title">
                          Get in touch
					</span>



                        <div class="wrap-input100 validate-input" data-validate="Name is required">
                          <input class="input100 shadow form-control" type="text" name="name" placeholder="Name" required />
                          <span class="focus-input100"></span>
                          <span class="symbol-input100">
                            <i class="fa fa-user" aria-hidden="true"></i>
                          </span>
                        </div>

                        <div class="wrap-input100 validate-input" data-validate="Valid email is required: ex@abc.xyz">
                          <input class="input100 shadow form-control" type="email" name="email" placeholder="Email" required />
                          <span class="focus-input100"></span>
                          <span class="symbol-input100">
                            <i class="fa fa-envelope" aria-hidden="true"></i>
                          </span>
                        </div>

                        <div class="wrap-input100 validate-input" data-validate="Message is required">
                          <textarea class="input100 shadow form-control" name="message" placeholder="Message" required></textarea>
                          <span class="focus-input100"></span>
                        </div>

                        <div class="container-contact100-form-btn">
                          <button class="main-button">
                            Send
						</button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <br />
                <br />
                <a
                  className="contact-detail-email"
                  href={"mailto:" + contactInfo.email_address}
                >
                  {contactInfo.email_address}
                </a>
                <br />
                <br />
                
              </div>
            </div>
           
          </div>
        </div>
      </div>
    </Fade>
  );
}
